<template>
    <section
        class="loader-gradient-background"
        :class="getBemModifiers()"
    >
        <slot />
    </section>
</template>

<script>
export default {
    name: 'LoaderGradientBackground',
};
</script>

<style lang="scss">
    $pageProductHeight: (
        'mobile': 60px,
        'desktop': 62px
    );

    .loader-gradient-background {
        position: relative;
        color: $color-slate20;
        width: 100%;
        min-height: 24px;
        @include floatingGradientBackground();

        &--market-selectable-input {
            height: 46px;
            width: 78%;
            margin: 0 11% 0 11%;
        }

        &--products-set-item-price {
            width: 85px;
            height: 36px;
        }

        &--products-set-item-qty {
            width: 108px;
            height: 36px;
        }

        &--products-buy-in-set-price {
            height: 24px;
        }

        &--products-buy-in-set-cta {
            height: 50px;
        }

        &--page-product-price {
            margin: -11px (-$spacing-default);
            width: calc(100% + #{ $spacing-default * 2 });
            text-align: center;

            @include set-same-block-height-and-line(map-get($pageProductHeight, 'mobile'));
            font-weight: $font-weight-bold;
            font-family: $goodHomeFontFamily;
            font-size: 16px;
        }
    }

    @media screen and (min-width: $mf-breakpoint-tablet) {
        .loader-gradient-background {
            &--market-selectable-input {
                width: 100%;
                margin: 0;
                height: 49px;
            }

            &--page-product-price {
                margin-top: -10px;
                margin-bottom: -10px;
                height: 58px;
                @include set-same-block-height-and-line(map-get($pageProductHeight, 'desktop'));
            }
        }
    }
</style>
